"use strict";

define('uikit/elements/checkbox',['marionette', '../channel', '../mixins/component.mixin', '../templates', '../extra/key.codes', 'semantic/modules/checkbox'], function (Mn, channel, ComponentMixin, Templates, KeyCodes) {
  var CheckboxView = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui checkbox',
    template: Templates.UIKit['checkbox'],
    triggers: {
      'focus @ui.input': {
        preventDefault: false,
        event: 'focus'
      }
    },
    events: {
      'keydown input[type="radio"],input[type="checkbox"]': function keydown_inputTypeRadioInputTypeCheckbox(ev) {
        if (!ev.ctrlKey && [KeyCodes.ENTER_KEY, KeyCodes.SPACE_KEY].includes(ev.keyCode)) {
          this.ui.input.focus();
        }
      },
      'click': function click(ev) {
        if (ev.target.tagName.toLowerCase() === 'a') {
          this.value = !this.value;
        }
      },
      'click input[type="checkbox"]': function click_inputTypeCheckbox(ev) {
        setTimeout(function () {
          $(ev.target).prop('checked', !$(ev.target).is(':checked'));
          $(ev.target).focus();
        }, 10);
      }
    },
    ui: {
      'input': 'input[type="radio"],input[type="checkbox"]'
    },
    options: {
      visible: true,
      radio: false,
      readonly: false,
      disabled: false,
      disableCheckboxModule: false,
      fitted: false,
      toggle: false,
      polar: false,
      slider: false,
      uncheckable: false,
      text: '',
      input: null,
      value: false
    },
    update: {
      value: false,
      visible: false,
      text: false,
      fitted: false
    },
    bindings: {},
    onFirstRender: function onFirstRender() {
      this.on('change:text', function () {
        if (!this.input) {
          this.$('label').text(this.text);
        }
      }, this).on('change:value', function () {
        if (this.readonly) {
          return;
        }
        if (this.value) {
          this.$el.checkbox('check');
        } else {
          this.$el.checkbox('uncheck');
        }
      }, this);
      if ($(this.el).find('strong').text()) {
        $(this.el).find('input').attr('aria-label', $(this.el).find('strong').text().replace(/[.()]/g, '').replace(/i/g, '$& '));
      }
    },
    onFocus: function onFocus() {
      var self = this;
      if (this.radio && this.input && this.input.ui.input.get(0) !== this._previousFocus) {
        _.defer(function () {
          if (self.ui.input.get(0) === document.activeElement) {
            self.input.focus();
          }
        });
      }
      this._previousFocus = null;
    },
    onInputFocus: function onInputFocus() {
      this._previousFocus = document.activeElement;
      if (this.radio && !this.readonly) {
        this.value = true;
      }
    },
    updateAttributes: function updateAttributes() {
      var self = this;
      this.addClass('fitted', this.getBoolOption('fitted')).addClass('toggle', this.getBoolOption('toggle')).addClass('polar', this.getBoolOption('polar')).addClass('slider', this.getBoolOption('slider')).addClass('radio', this.getBoolOption('radio')).addClass('read-only', this.getBoolOption('readonly')).addClass('disabled', this.getBoolOption('disabled'));
      if (!this.disableCheckboxModule) {
        this.$el.checkbox({
          fireOnInit: false,
          onChange: function onChange() {
            self._internal.value = self.$el.checkbox('is checked');
          }
        });
      } else {
        this.$el.checkbox('destroy');
      }
    }
  });
  channel.reply('checkbox', function () {
    return CheckboxView;
  });
  return CheckboxView;
});

